module.exports = __webpack_public_path__ + "img/heart.815c29f8.png";